var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBinancepay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 94.5",
    style: {
      enableBackground: "new 0 0 500 94.5"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F0B90B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(-39.87 -50.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "st0",
    d: "M73.6,97.8l-7.6,7.6l-7.6-7.6l7.6-7.6L73.6,97.8z M92.1,79.3l13.1,13.1l7.6-7.6L92.1,64.1 L71.4,84.7l7.6,7.6L92.1,79.3z M118.3,90.2l-7.6,7.6l7.6,7.6l7.6-7.6L118.3,90.2z M92.1,116.3l-13.1-13.1l-7.6,7.6l20.7,20.7 l20.7-20.7l-7.6-7.6L92.1,116.3z M92.1,105.4l7.6-7.6l-7.6-7.6l-7.6,7.6L92.1,105.4z M172.6,106.2v-0.1c0-5-2.6-7.5-6.9-9.1 c2.6-1.5,4.9-3.8,4.9-8v-0.1c0-5.8-4.7-9.6-12.2-9.6h-17.2v37h17.6C167.1,116.3,172.6,112.9,172.6,106.2L172.6,106.2z M162.4,90.3 c0,2.7-2.3,3.9-5.9,3.9h-7.5v-7.8h8C160.5,86.4,162.4,87.8,162.4,90.3L162.4,90.3z M164.5,105.1c0,2.7-2.2,4-5.8,4h-9.7V101h9.4 C162.6,101,164.5,102.6,164.5,105.1L164.5,105.1z M189.7,116.3v-37h-8.2v37H189.7z M233.5,116.3v-37h-8.1v22.8l-17.3-22.8h-7.5v37 h8V92.8l17.9,23.5H233.5z M278.6,116.3L262.7,79h-7.5l-15.9,37.3h8.3l3.4-8.3h15.7l3.4,8.3H278.6z M263.8,100.8h-9.9l4.9-12 L263.8,100.8z M317.4,116.3v-37h-8.1v22.8L292,79.3h-7.5v37h8V92.8l17.9,23.5H317.4z M359.4,110.3l-5.2-5.2 c-2.9,2.6-5.5,4.3-9.7,4.3c-6.3,0-10.7-5.3-10.7-11.6v-0.1c0-6.3,4.5-11.5,10.7-11.5c3.7,0,6.6,1.6,9.5,4.2l5.2-6 c-3.4-3.4-7.6-5.7-14.6-5.7c-11.4,0-19.3,8.6-19.3,19.1v0.1c0,10.6,8.1,19,19,19C351.4,117,355.6,114.4,359.4,110.3L359.4,110.3z  M394.2,116.3v-7.3h-20.1v-7.8h17.5V94h-17.5v-7.5h19.8v-7.3H366v37L394.2,116.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.3,47.3c-0.8,1.6-1.9,3-3.3,4.1c-1.4,1.1-3,1.9-4.8,2.5c-1.8,0.6-3.8,0.8-5.9,0.8H378v11.3h-8.3V28.4h15.4 c2.3,0,4.3,0.3,6.1,0.9c1.8,0.6,3.3,1.5,4.5,2.7c1.2,1.1,2.2,2.5,2.9,4.1c0.7,1.6,1,3.4,1,5.3v0.1 C399.5,43.8,399.1,45.7,398.3,47.3z M391.1,41.6c0-1.9-0.6-3.3-1.8-4.3c-1.2-1-2.8-1.5-4.9-1.5H378v11.5h6.6 c2.1,0,3.7-0.5,4.8-1.6c1.1-1.1,1.7-2.4,1.7-4.1V41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.7,66.1l-3.4-8.4h-15.9l-3.4,8.4h-8.4l16.1-37.9h7.6l16.1,37.9H433.7z M422.3,38.1l-5,12.2h10L422.3,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,51.1v15h-8.3V51.3l-14.5-22.8h9.7l9,15.1l9.1-15.1h9.4L467,51.1z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBinancepay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BINANCEPAY.4e77cc5dacfda9115086ec9ddd52b8fe.svg";